export default "__VITE_ASSET__Cdswg7TH__"